const updates = [
  { date: '07-30', tag: '平台更新', title: '久久视频暑期档片单全面上线，多部热门剧集同步更新' },
  { date: '07-29', tag: '内容推荐', title: '芒果视频最新自制综艺本周开播，独家策划看点十足' },
  { date: '07-28', tag: '新站入驻', title: '蓝莓视频高清专区完成对接，超清画质体验全新升级' },
  { date: '07-27', tag: '功能优化', title: '青青草视频移动端页面适配优化，访问速度提升40%' },
  { date: '07-26', tag: '平台更新', title: '97视频新增个性化推荐算法，内容匹配度大幅提高' },
  { date: '07-25', tag: '内容推荐', title: '丝瓜视频纪录片频道更新，多部高分自然纪录片上线' },
  { date: '07-24', tag: '行业动态', title: '在线视频行业持续增长，高清视频网站用户规模创新高' },
  { date: '07-23', tag: '平台更新', title: '91在线视频经典片库修复项目启动，多部老片画质提升' },
  { date: '07-22', tag: '内容推荐', title: '糖心视频社区话题挑战赛火热进行中，参与互动赢好礼' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-flashlight-line"></i>
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            平台快讯实时追踪
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            第一时间获取各大视频平台的最新动态与内容更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''} group cursor-pointer`}
              >
                <div className="absolute -left-[25px] top-0.5 w-3 h-3 rounded-full bg-background-50 border-2 border-accent-400 group-hover:border-accent-500 group-hover:bg-accent-100 transition-colors"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-accent-600 whitespace-nowrap sm:min-w-[44px]">{item.date}</span>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-1.5">
                      {item.tag}
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed group-hover:text-foreground-900 transition-colors">{item.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}